import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import FinancialA from './FinancialA';
import Fundaraising from './Fundaraising';
import ReferencesFF from './ReferencesFF';
import ValidationFF from './ValidationFF';
const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const EntrepreneurshipFF = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#FAF') {
      setBackI(appColors['ColorF']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#FFF') {
      setBackI('transparent');
      setBackII(appColors['ColorF']);
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#VFF') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorF']);
      setBackIV('transparent');
    } else if (key === '#VFE') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorF']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#FAF' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorF'], fontSize: '2.1vh'}}>Financial Analysis</Text></Content>}/>
          <Link href='#FFF' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorF'], fontSize: '3vh'}}>Fundraising</Text></Content>}/>
          <Link href='#VFF' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorF'], fontSize: '3vh'}}>Validation</Text></Content>}/>
          <Link href='#VFE' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorF'], fontSize: '3vh'}}>References</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorF'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> F&nbsp;<br/> I&nbsp;<br/> N&nbsp;<br/> A&nbsp;<br/> N&nbsp;<br/> C&nbsp;<br/> I&nbsp;<br/> A&nbsp;<br/> L&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['Colorx'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='FAF'>
              <FinancialA/>
            </div>
            <div id='FFF'>
              <Fundaraising/>
            </div>
            <div id='VFF'>
              <ValidationFF/>
            </div>
            <div id='VFE'>
              <ReferencesFF/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default EntrepreneurshipFF;
